module.exports = {
  title: 'Répertoriez votre activité sur FishFriender',
  subtitle:
    'Vous êtes professionnel de la pêche, guide, camp de pêche, moniteur, école, association, magasin, fabricant, ... ?',
  intro:
    'FishFriender vous permet de communiquer sur votre activité au sein de la communauté. Vous gagnez en visibilité et votre réferencement est gratuit. Les utilisateurs pourront vous localiser et vous contacter plus rapidement.',
  warning:
    "La fonctionnalité de recherche n'est pas encore active pour les utilisateurs, si vous souhaitez être dans les premiers réferencés, remplissez le formulaire suivant.",
  continue: {
    intro:
      'Vous pouvez modifier ici les informations concernant votre activité. Si vous le osuhaitez, vous pouvez y revenir plus tard grâce au lien suivant :',
    warning:
      "Plus que quelques étapes pour réferencer votre activité ! En cas de problème, n'hésitez pas à nous contacter en utilisant le bouton help en bas à droite de cette page.<br/><br/>Une fois toutes les informations remplies, n'oubliez pas de soumettre !",
    warningDone:
      "Votre activité a bien été soumise. Vous serez averti par email de l'avancement. La plateforme de référencement n'est pas encore disponible pour le grand public, nous vous tiendrons au courant de sa sortie.",
  },
  startSubmissionButton: 'Enregistrer mon activité',
  form: {
    savedSnackbar: 'Sauvegarde effectuée',
    missingData: 'Le formulaire est incomplet.',
    serverError:
      "Une erreur est survenue. Merci de réessayer. Si le problème persiste, vous pouvez nous contacter via le bouton d'aide en bas à droite de cette fenêtre ou par mail à <b>contact@fishfriender.com</b> . Merci de joindre le message technique suivant :",
    actions: {
      next: 'suivant >',
      previous: '< précédent',
      save: 'Sauvegarder',
      submit: 'Soumettre mon activité',
    },
    confirmModal: {
      missingTitle: 'Informations manquantes',
      missingContent:
        'Merci de compléter les tâches obligatoires, sans quoi il n\'est pas possible de valider votre activité.<br/><br/> En cas de soucis n\'hésitez pas à nous contacter en utilisant le bouton d\'aide en bas à droite de cet écran ou par mail à <a href="mailto:contact@fishfriender.com" target="_blank">contact@fishfriender.com</a>',
      intro:
        'En soumettant votre activité, elle sera envoyée à nos équipes à des fins de vérification et de modération. Une fois soumise, les détails de votre activité ne pourront pas être modifiés avant leur publication sur le site. Lors de la publication, vous aurez un accès à une interface de gestion et de modification de ces informations.',
    },
    titles: {
      basic: 'Informations vous concernant',
      administrative: 'Informations à propos de votre activité',
      agreement: 'Agrément',
      position: 'Emplacement',
      pictures: 'Photos',
      countriesLanguages: 'Pays et Langues',
      fishingType: 'Votre pêche',
      globalPresentation: 'Description',
      licenses: 'Licences et accréditations',
      confirmModal: 'Soumettre mon activité',
    },
    subtitles: {
      basic: 'Au cas où nous ayons besoin de vous contacter',
      administrative: 'Fournissez les informations concernant votre activité',
      agreement: 'Justificatif de votre activité, utilisé uniquement à des fins de vérification',
      position: 'Indiquez à quel endroit précis les utilisateurs peuvent vous trouver',
      pictures: 'Illustrez votre fiche en ajoutant de 1 à 4 photos',
      countriesLanguages: 'Quelles langues parlez-vous ? Quels pays visez-vous ?',
      fishingType: 'Quelles pêches pratiquez / vendez / enseignez -vous ?',
      globalPresentation: "Quelles sont vos horaires d'ouverture ? Pouvez-vous vous décrire en quelques mots ?",
      licenses: 'Joignez ici vos justificatifs de licenses, accréditations, diplômes...',
    },
    optionalDataTitle:
      "Les données ci-dessous sont optionnelles. Néanmoins, nous vous conseillons d'en renseigner le maximum afin d'améliorer votre réferencement et votre attraction auprès de nos utilisateurs.",
    contact: {
      intro:
        'Merci de renseigner les informations permettant à nos équipes de vous contacter en cas de besoin concernant votre activité. <br/><br/><i>Tous les champs sont obligatoires.</i>',
      email: {
        label: 'Votre email',
        tooltip:
          "Merci de renseigner votre adresse mail, et non celle de votre activité. Cet email nous servira à vous contacter en cas de besoin concernant votre activité, et devra être confirmée pour valider la soumission de l'activité.",
        help: 'Exemple: monemail@example.com',
      },
      firstName: {
        label: 'Votre prénom',
      },
      lastName: {
        label: 'Votre nom',
      },
      position: {
        label: 'Votre fonction',
        tooltip: "Votre fonction au sein de l'activité : propriétaire, dirigeant, vendeur, marketing, etc...",
      },
    },
    activity: {
      intro:
        "Renseignez ici les informations relatives à l'activité que vous souhaitez référencer.<br/><br/><i>Les champs marqués d'un astérisque sont obligatoires</i>",
      name: {
        label: "Nom de l'activité",
        tooltip: 'Le nom de votre activité comme il apparaîtra dans les résultats de recherche',
      },
      type: {
        label: 'Type',
        selectTitle: 'Sélectionnez',
        other: 'Autre (précisez)',
      },
      website: {
        label: 'Site web',
        tooltip:
          "Le lien vers le site web présentant l'activité. Les utilisateurs seront redirigés vers ce site web. \nMerci de préciser le lien complet, en incluant le prefix <b>http</b> ou <b>https</b>",
        help: 'Exemple: http://www.example.com',
      },
      email: {
        label: 'Email de contact',
        tooltip: 'Email utilisée par les utilisateurs pour vous contacter',
        help: 'Exemple: monemail@example.com',
      },
      phone: {
        label: 'Téléphone',
        tooltip:
          "Le numéro de téléphone auquel les utilisateurs pourraient vous joindre concernant votre activité. Merci de préciser l'indicatif du pays.",
      },
      proofDocument: {
        label: 'Agrément',
        tooltip:
          "Document justifiant l'existence de votre activité : Kbis, certificat d'assurance, etc...<br/>Formats acceptés : png, jpg ou pdf<br/><br/>FishFriender s'engage à garder ce document confidentiel et à ne l'utiliser qu'à des fins de vérification.",
        tooLarge: 'Le fichier ne peut pas excéder 5mo.',
      },
    },
    agreement: {
      intro:
        "Document justifiant l'existence de votre activité : Kbis, certificat d'assurance, etc...<br/>Formats acceptés : png, jpg ou pdf<br/><br/>FishFriender s'engage à garder ce document confidentiel et à ne l'utiliser qu'à des fins de vérification.",
      fileSubmitted: 'Vous avez déjà soumis un fichier <b>%(extension)s</b> %(date)s',
      fileNotSubmitted: "Aucun fichier n'a été soumis pour le moment",
      selectedFile: 'Fichier selectionné : <br/> <b>%(filename)s</b>',
      noSelectedFile: 'Aucun fichier selectionné',
      uploadDescription: 'Cliquez ou glissez un fichier ici pour le selectionner',
    },
    location: {
      intro:
        "Indiquez à quel endroit précis les utilisateurs peuvent vous trouver. Pour les guides et excursions, indiquez le point de départ habituel. Pour les activités fixes comme les lodges ou les magasins, merci d'indiquer la porte d'entrée.",
      clickMapTitle: 'Cherchez une adresse ou cliquez pour indiquer le point précis',
      searchPlaceholder: 'Recherchez un lieu',
      markerPosition: 'Position du point selectionné: ',
      address: {
        intro: "Précisez l'adresse à laquelle les utilisateurs peuvent vous trouver :",
      },
      addressStreetNumber: {
        label: 'Numéro',
      },
      addressStreet: {
        label: 'Rue',
      },
      addressPostalCode: {
        label: 'Code postal',
      },
      addressCity: {
        label: 'Ville',
      },
      addressAdministrativeAreaLevel1: {
        label: 'Région',
      },
      addressCountry: {
        label: 'Pays',
      },
    },
    images: {
      intro:
        'Selectionnez <b>1 à 4</b> photos présentant votre activité. Les photos doivent être appropriées, de bonne qualité et en rapport avec votre activité. Merci de vérifiez que vous avez les droits de publication sur ces images.',
      filesSubmitted: 'Fichiers déjà enregistrés : ',
      filesSelected: 'Fichiers selectionnés : ',
      uploadDescription: 'Cliquez ou déposez des photos ici',
    },
    additional: {
      intro:
        'Renseignez ici les informations qui aiguilleront les utilisateurs sur le profil de pêche de votre activité. Ces informations serviront dans la recherche et le réferencement.<br/><br/><i>Tout ces champs sont facultatifs, mais plus vous êtes précis, plus les utilisateurs seront susceptibles de vous trouver.',
      catchMethods: {
        label: 'Techniques de pêche utilisées / enseignées / vendues',
        selectHeader: '+ Ajouter',
        tooltip:
          'Sélectionnez les techniques de pêche privilégiées par votre activité : celles dont vous vendez le matériel, ou celles que vous utilisez particulièrement en tant que guide, etc...',
        other: 'Autre',
        addOther: '+ ajouter',
      },
      targetedFish: {
        label: 'Poissons visés: ',
        fresh: 'Eau douce',
        salt: 'Eau salée',
      },
      countries: {
        label: 'Pays ciblés',
        tooltip:
          'Indiquez le ou les pays dans lesquels vous êtes présents (exemple : si vous êtes une marque, dans quels pays peut-on trouver votre matériel, si vous êtes un guide, où emmenez vous vos clients, etc...)',
        selectHeader: '+ Ajouter',
        continentOptions: {
          NORTH_AMERICA: "Toute l'Amérique du Nord",
          SOUTH_AMERICA: "Toute l'Amérique du Sud",
          AFRICA: "Toute l'Afrique",
          EUROPE: "Toute l'Europe",
          ASIA: "Toute l'Asie",
          OCEANIA: "Toute l'Océanie",
        },
        continent: {
          NORTH_AMERICA: 'Amérique du Nord',
          SOUTH_AMERICA: 'Amérique du Sud',
          AFRICA: 'Afrique',
          EUROPE: 'Europe',
          ASIA: 'Asie',
          OCEANIA: 'Océanie',
        },
        optionsContinents: 'Continents',
        optionsOrCountries: 'Pays',
      },
      languages: {
        label: 'Langues parlées',
        selectHeader: '+ Ajouter',
      },
      description: {
        label: 'Présentation',
        tooltip:
          "Ecrivez ici une présentation de votre activité, en précisant toute donnée pertinente non inclue précédemment dans le formulaire. <br/><br/>Merci de ne pas mettre de lien, de numéro ou d'email.",
      },
      startDate: {
        label: "Date de début d'activité",
      },
      workingHours: {
        label: 'Horaires de fonctionnement',
      },
      brands: {
        label: 'Marques principalement utilisées / vendues',
        placeholder: 'Recherchez une marque',
        floatingLabel: '%(nb)s résultats',
      },
      accreditationFiles: {
        title: 'Licenses et accréditations',
        intro:
          "Si vous avez des licenses, accréditations, diplômes, permis ou qualifications spécifiques, vous pouvez joindre ici les fichiers justificatifs, et ces qualifications seront affichées sur la page de l'activité. Ces fichiers ne seront utilisés que par les équipes de FishFriender à des fins de vérification.<br/><br/>Exemples: <i><ul><li>Brevet Professionnel de Moniteur-Guide de Pêche de Loisirs,</li><li>Certificat de Spécialisation d'initiative locale,</li><li>Fédération Française des moniteurs guides de pêche,</li><li>Records IGFA</li></ul><br/>Vous pouvez joindre jusqu'à 5 fichiers, de 5mo max chacun. Vous pouvez joindre des images (png, jpg) ou des pdf.",
        uploadDescription: 'Cliquez ou glissez ici les fichiers',
        wrongFileFormat: 'Format acceptés : .png, .jpg, .jpeg, .pdf',
        tooManyFiles: "Vous pouvez joindre jusqu'à 5 fichiers",
        maxFileSize: 'Chaque fichier ne peut excéder 5mo',
        filesNotSubmitted: 'Aucun fichier déposé pour le moment',
        filesSubmitted:
          'Vous avez déjà enregistré %(numberOfFiles)d fichiers. Pour des raisons de sécurité, étant des documents sensibles, ils ne sont pas affichés.',
        deleteSubmittedFiles: 'Supprimer les fichiers déjà enregistrés',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer les fichiers préalablement envoyés ?',
        selectedFile: 'Fichier selectionné pour envoi : <b>%(filename)s</b>',
      },
    },
  },
  summary: {
    title: 'Verification',
    intro: "Merci de vérifier l'exactitude des données entrées.",
    contact: 'Contact',
    activity: 'Votre activité',
    activityProof: 'Justificatif',
    location: 'Localisation',
    images: 'Photos',
    additional: {
      title: 'Données supplémentaires',
      countries: 'Pays ciblés: ',
      languages: 'Langues parlées: ',
      brands: 'Marques principalement utilisées: ',
      catchMethods: 'Techniques employées: ',
      targetedFishes: 'Poissons visés: ',
      startDate: 'Date de mise en activité: ',
      workingHours: 'Horaires: ',
      description: 'Présentation: ',
      accreditationFiles: 'Accréditations: ',
    },
    agreedText:
      'En cochant cette case, vous déclarez être en position légale de mettre ces informations en ligne. Vous acceptez également que ces informations soient diffusées sur le réseau FishFriender.',
    cancelButton: 'Annuler',
    confirmButton: 'Envoyer',
    confirmButtonOk: 'Ok',
    errorSent:
      'Une erreur est survenue, merci de réessayer dans quelques instants.<br/> Si le problème persiste, merci de nous contacter à <a href="mailto:contact@fishfriender.com">contact@fishfriender.com</a>',
    successfullySent:
      "Vos données ont bien été envoyées. Vous allez recevoir un email à l'adresse %(email)s, merci de cliquer sur le lien fourni dans cet email pour confirmer que cette adresse est bien la votre. Une fois votre adresse confirmée, nos équipes vérifieront vos informations et reviendront vers vous.",
  },
}
